














































import {Component, Prop, Vue} from "vue-property-decorator";

@Component({})
export default class DeleteButton extends Vue {
    state: string = "button"; //button, asking, deleting,
    @Prop({}) action!:string;
    message:string = "";
    get displayDialog(): boolean {
        return this.state != "button";
    }

    get displayCancel(): boolean {
        return this.state == "asking";
    }

    get title(): string {
        return "Emin misiniz?";
    }

    get content(): string {
        return "Seçtiğiniz kayıt kalıcı olarak silinecektir. Devam etmek istediğinize emin misiniz?";
    }

    ask() {
        this.state = "asking";
    }

    cancel() {
        this.state = "button";
        if (this.state == 'asking') {
        }
    }

    send() {
        this.message = "";
        //console.log("action",this.action);
        this.state = 'deleting';
        Vue.prototype.$http.delete(this.action).then(() => {
            this.$emit('deleted');
            this.state = 'button';
        }).catch((e:any) => {
            if(typeof e.response != "undefined"){
                if(typeof e.response.data.messages != "undefined"){
                    e.response.data.messages.forEach((message:any)=>{
                        this.message+= message.message +"</br>";
                    })
                }
                if(typeof e.response.data.message != "undefined"){
                    this.message = e.response.data.message;
                }
            }else{
                this.message = e.message;
            }
            this.state = "error";
        })
    }
}
